// import React, { useState } from "react";
// import { Col, Container, Form, Row } from "react-bootstrap";
// import CommonHeading from "../../Common_Components/Common_Heading/Common_Heading";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faCloudArrowUp,
//   faFile,
//   faPlus,
//   faXmark,
// } from "@fortawesome/free-solid-svg-icons";
// import "./Why_Apply_With_Us.css";
// import Common_Button from "../../Common_Components/common_button/Common_Button";
// import Success_Modal from "../../Common_Components/common_modal/success_modal/Success_Modal";
// import PhoneInput from "react-phone-input-2";

// const Why_Apply_With_Us = () => {
//   const benefits = [
//     {
//       title: "Government Approved",
//       description:
//         "Fully recognized and supported by Ministry of External Affairs, Govt. of India.",
//     },
//     {
//       title: "Quick Processing",
//       description:
//         "Fast evaluation and visa/document processing for all matching candidates.",
//     },
//     {
//       title: "Expert Team",
//       description:
//         "Your application is reviewed by experienced global manpower professionals.",
//     },
//   ];

//   const [resumeFile, setResumeFile] = useState(null);
//   const [previewUrl, setPreviewUrl] = useState("");
//   const [showSuccessModal, setShowSuccessModal] = useState(false);
//   const [phone, setPhone] = useState("");

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];

//     if (!file) return;

//     setResumeFile(file);

//     // Create preview only for image files
//     if (file.type.startsWith("image/")) {
//       setPreviewUrl(URL.createObjectURL(file));
//     } else {
//       setPreviewUrl("");
//     }
//   };

//   const removeFile = () => {
//     setResumeFile(null);
//     setPreviewUrl("");
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Your API / form submission logic here
//     setShowSuccessModal(true);
//   };

//   return (
//     <>
//       <section className="Why_Apply_With_Us">
//         <Container>
//           <Row>
//            <Col md={4}>
//               <div className="application_benefits">
//                 <CommonHeading title="Why Apply With Us?" />
//                 {benefits.map((item, index) => (
//                   <div className="benefit_card" key={index}>
//                     <h3>{item.title}</h3>
//                     <p>{item.description}</p>
//                   </div>
//                 ))}
//               </div>
//             </Col>

//             {/* FORM */}
//             <Col md={12}>
//               <div className="application_form_wrapper">
//                 <div className="application_form_header">
//                   <h2>Application Form</h2>
//                   <p>
//                     Fill in your details below to apply for placement
//                     opportunities
//                   </p>
//                 </div>

//                 <Form className="application_form" onSubmit={handleSubmit}>
//                   {/* FULL NAME */}
//                   <Form.Group className="form_group">
//                     <Form.Label>
//                       Full Name <span>*</span>
//                     </Form.Label>
//                     <Form.Control
//                       type="text"
//                       placeholder="Enter your full name"
//                       required
//                     />
//                   </Form.Group>

//                   {/* EMAIL */}
//                   <Form.Group className="form_group">
//                     <Form.Label>
//                       Email Address <span>*</span>
//                     </Form.Label>

//                     <Form.Control
//                       type="email"
//                       placeholder="Enter your email"
//                       required
//                     />
//                   </Form.Group>

//                   {/* PHONE */}
//                   <Form.Group className="form_group">
//                     <Form.Label>
//                       Phone Number <span>*</span>
//                     </Form.Label>

//                     <PhoneInput
//                       country={"in"}
//                       value={phone}
//                       onChange={(phone) => setPhone(phone)}
//                       placeholder="Enter your phone number"
//                       inputClass="phone_input"
//                       containerClass="phone_input_container"
//                       buttonClass="phone_country_btn"
//                       required
//                     />

//                     {/* <Form.Control
//                       type="tel"
//                       maxLength={10}
//                       placeholder="Enter your phone number"
//                     /> */}
//                   </Form.Group>

//                   {/* JOB POSITION */}
//                   <Form.Group className="form_group">
//                     <Form.Label>
//                       Job Position <span>*</span>
//                     </Form.Label>

//                     <Form.Control
//                       type="text"
//                       placeholder="e.g., HVAC Engineer, Nurse, IT Professional"
//                       required
//                     />
//                   </Form.Group>

//                   {/* EXPERIENCE */}
//                   <Form.Group className="form_group">
//                     <Form.Label>
//                       Experience <span>*</span>
//                     </Form.Label>

//                     <Form.Control
//                       type="text"
//                       placeholder="e.g., 5 years in Healthcare, 2 years in Construction"
//                       required
//                     />
//                   </Form.Group>

//                   {/* MESSAGE */}
//                   <Form.Group className="form_group">
//                     <Form.Label>
//                       Message <small>(Optional)</small>
//                     </Form.Label>

//                     <Form.Control
//                       as="textarea"
//                       rows={3}
//                       placeholder="Tell us about yourself and why you are applying..."
//                     />
//                   </Form.Group>

//                   {/* RESUME */}
//                   <Form.Group className="form_group">
//                     <Form.Label>
//                       Upload Resume/CV <span>*</span>
//                     </Form.Label>

//                     {!resumeFile ? (
//                       <label className="resume_upload">
//                         <Form.Control
//                           type="file"
//                           hidden
//                           accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
//                           onChange={handleFileChange}
//                           required
//                         />

//                         <FontAwesomeIcon
//                           icon={faPlus}
//                           className="upload_plus_icon"
//                         />

//                         <strong>Click to upload or drag and drop</strong>

//                         <small>PDF, DOC, DOCX, JPG, PNG (Max 5MB)</small>
//                       </label>
//                     ) : (
//                       <div className="resume_preview">
//                         {previewUrl ? (
//                           <img
//                             src={previewUrl}
//                             alt="Resume Preview"
//                             className="resume_preview_img"
//                           />
//                         ) : (
//                           <div className="resume_file_icon">
//                             <FontAwesomeIcon icon={faFile} />
//                           </div>
//                         )}

//                         <div className="resume_file_details">
//                           <strong>{resumeFile.name}</strong>
//                           {/* <small>
//                           {(resumeFile.size / (1024 * 1024)).toFixed(2)} MB
//                         </small> */}
//                         </div>

//                         <button
//                           type="button"
//                           className="resume_remove_btn"
//                           onClick={removeFile}
//                         >
//                           <FontAwesomeIcon icon={faXmark} />
//                         </button>
//                       </div>
//                     )}
//                   </Form.Group>

//                   <Common_Button
//                     type="submit"
//                     text="Submit Application "
//                     icon={faCloudArrowUp}
//                     className="application_submit_btn"
//                   />
//                 </Form>
//               </div>
//             </Col>

             
//           </Row>
//         </Container>
//       </section>

//       <Success_Modal
//         show={showSuccessModal}
//         onHide={() => setShowSuccessModal(false)}
//       />
//     </>
//   );
// };

// export default Why_Apply_With_Us;

import React, { useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import CommonHeading from "../../Common_Components/Common_Heading/Common_Heading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCloudArrowUp,
  faFile,
  faPlus,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import "./Why_Apply_With_Us.css";
import Common_Button from "../../Common_Components/common_button/Common_Button";
import Success_Modal from "../../Common_Components/common_modal/success_modal/Success_Modal";
import PhoneInput from "react-phone-input-2";

const Why_Apply_With_Us = () => {
  const benefits = [
    {
      title: "Government Approved",
      description:
        "Fully recognized and supported by Ministry of External Affairs, Govt. of India.",
    },
    {
      title: "Quick Processing",
      description:
        "Fast evaluation and visa/document processing for all matching candidates.",
    },
    {
      title: "Expert Team",
      description:
        "Your application is reviewed by experienced global manpower professionals.",
    },
  ];

  const [resumeFile, setResumeFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [phone, setPhone] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    setResumeFile(file);

    if (file.type.startsWith("image/")) {
      setPreviewUrl(URL.createObjectURL(file));
    } else {
      setPreviewUrl("");
    }
  };

  const removeFile = () => {
    setResumeFile(null);
    setPreviewUrl("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowSuccessModal(true);
  };

  return (
    <>
      <section className="Why_Apply_With_Us">
        <Container>

          {/* ================= BENEFITS ================= */}
          <div className="application_benefits">
            <CommonHeading title="Why Apply With Us?" />

            <Row className="g-3">
              {benefits.map((item, index) => (
                <Col md={4} key={index}>
                  <div className="benefit_card">
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </div>

          {/* ================= APPLICATION FORM ================= */}
          <Row>
            <Col md={12}>
              <div className="application_form_wrapper">
                <div className="application_form_header">
                  <h2>Application Form</h2>
                  <p>
                    Fill in your details below to apply for placement
                    opportunities
                  </p>
                </div>

                <Form
                  className="application_form"
                  onSubmit={handleSubmit}
                >
                  {/* FULL NAME */}
                  <Form.Group className="form_group">
                    <Form.Label>
                      Full Name <span>*</span>
                    </Form.Label>

                    <Form.Control
                      type="text"
                      placeholder="Enter your full name"
                      required
                    />
                  </Form.Group>

                  {/* EMAIL */}
                  <Form.Group className="form_group">
                    <Form.Label>
                      Email Address <span>*</span>
                    </Form.Label>

                    <Form.Control
                      type="email"
                      placeholder="Enter your email"
                      required
                    />
                  </Form.Group>

                  {/* PHONE */}
                  <Form.Group className="form_group">
                    <Form.Label>
                      Phone Number <span>*</span>
                    </Form.Label>

                    <PhoneInput
                      country={"in"}
                      value={phone}
                      onChange={(phone) => setPhone(phone)}
                      placeholder="Enter your phone number"
                      inputClass="phone_input"
                      containerClass="phone_input_container"
                      buttonClass="phone_country_btn"
                      required
                    />
                  </Form.Group>

                  {/* JOB POSITION */}
                  <Form.Group className="form_group">
                    <Form.Label>
                      Job Position <span>*</span>
                    </Form.Label>

                    <Form.Control
                      type="text"
                      placeholder="e.g., HVAC Engineer, Nurse, IT Professional"
                      required
                    />
                  </Form.Group>

                  {/* EXPERIENCE */}
                  <Form.Group className="form_group">
                    <Form.Label>
                      Experience <span>*</span>
                    </Form.Label>

                    <Form.Control
                      type="text"
                      placeholder="e.g., 5 years in Healthcare, 2 years in Construction"
                      required
                    />
                  </Form.Group>

                  {/* MESSAGE */}
                  <Form.Group className="form_group">
                    <Form.Label>
                      Message <small>(Optional)</small>
                    </Form.Label>

                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Tell us about yourself and why you are applying..."
                    />
                  </Form.Group>

                  {/* RESUME */}
                  <Form.Group className="form_group">
                    <Form.Label>
                      Upload Resume/CV <span>*</span>
                    </Form.Label>

                    {!resumeFile ? (
                      <label className="resume_upload">
                        <Form.Control
                          type="file"
                          hidden
                          accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                          onChange={handleFileChange}
                          required
                        />

                        <FontAwesomeIcon
                          icon={faPlus}
                          className="upload_plus_icon"
                        />

                        <strong>
                          Click to upload or drag and drop
                        </strong>

                        <small>
                          PDF, DOC, DOCX, JPG, PNG (Max 5MB)
                        </small>
                      </label>
                    ) : (
                      <div className="resume_preview">
                        {previewUrl ? (
                          <img
                            src={previewUrl}
                            alt="Resume Preview"
                            className="resume_preview_img"
                          />
                        ) : (
                          <div className="resume_file_icon">
                            <FontAwesomeIcon icon={faFile} />
                          </div>
                        )}

                        <div className="resume_file_details">
                          <strong>{resumeFile.name}</strong>
                        </div>

                        <button
                          type="button"
                          className="resume_remove_btn"
                          onClick={removeFile}
                        >
                          <FontAwesomeIcon icon={faXmark} />
                        </button>
                      </div>
                    )}
                  </Form.Group>

                  <Common_Button
                    type="submit"
                    text="Submit Application "
                    icon={faCloudArrowUp}
                    className="application_submit_btn"
                  />
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Success_Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
      />
    </>
  );
};

export default Why_Apply_With_Us;
